import { useContext } from "react";

import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Col from 'react-bootstrap/Col';

import { AuthContext } from '../../store/AuthContext';

import './index.css';

import MenuDireito from "./MenuDireito";
import MenuEsquerdo from "./MenuEsquerdo";

import EctLogo from '../../assets/img/logo-ect.png';

const Header = () => {

  const { login } = useContext(AuthContext);

  return (

    <>

      <Navbar key='xll' bg="light" expand='xll' className="mb-3" fixed="top">
        <Container fluid id='header-menu'>
          <Col sm={12} md={12} lg={5}>
            {login ?
            <MenuEsquerdo />
            : <></> }
            <img src={EctLogo} alt="Logo ECT" />
          </Col>
          <Col sm={12} md={12} lg={7}>
            <MenuDireito />
          </Col>

        </Container>
      </Navbar>

    </>

  )
}

export default Header